import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'

/** Small spinner shown while a cached list refetches in the background. */
export function ListRefreshIndicator({
  visible,
  className,
}: {
  visible: boolean
  className?: string
}) {
  if (!visible) return null
  return (
    <div
      className={cn(
        'pointer-events-none absolute right-4 top-0 z-10 flex h-8 items-center',
        className,
      )}
      role="status"
      aria-label="Updating list"
    >
      <Loader2 className="h-4 w-4 animate-spin text-gray-400" />
    </div>
  )
}
